import React, { useContext, useState } from 'react';
import Button from '../../../ui/Button';
import styled from 'styled-components';
import { CartContext } from '@/store/context/cart';
import { NotificationsContext } from '@/store/context/notifications';
import { addToCart, changeQuantity, findInCart, getCart, removeFromCart } from '@/store/ls/cart';
import { TableString } from '@/pages/search/[search]';
import { ISearchPrep } from '@/types/search';
import Counter from '../../../ui/Counter';
import { beautyPrice, getBlockedText, getMaxQuantity, getMinQuantity, getQuantityStep } from '@/helpers/ost';
import useDeviceDetect from '../../../helpers/hooks';
import { locales } from '@/helpers/locales';
import Image from 'next/image';

export default function SearchString({prep, openObjectsModal}: {prep: ISearchPrep, openObjectsModal: Function}) {
  
  const { cart, setCart } = useContext(CartContext);
  const { add } = useContext(NotificationsContext);
  const { isMobile } = useDeviceDetect();

  const [ quantity, setQuantity ] = useState(getMinQuantity(prep.id));

  const [hovered, setHovered] = useState(false);

  
  const removeFromCartHandler = (prepId: number) => {
    removeFromCart(prepId);
    setCart(getCart());
  }
  
  const addToCartHandler = (prep: ISearchPrep) => {
    if (cart.length < 10) {
      addToCart({
        prep_id: prep.id,
        rcfi_name: prep.rcfi_name,
        proizv_name: prep.proizv_name,
        quantity,
        min_price: prep.min_price,
        need_recipe: prep.need_recipe
      })
      setCart(getCart());
      add({
        title: 'Товар добавлен в корзину',
        button: <Button href="/cart" color="white">Перейти в корзину</Button>
      });
    } else {
      add({
        title: 'Можно забронировать до 10 наименований',
        button: <Button href="/cart" color="white">Перейти в корзину</Button>,
        color: 'attention'
      });
    }
  }

  
  const onCounterChange = (newValue: number) => {
    if(!findInCart(cart, prep.id)){
      setQuantity(newValue);
    } else {
      changeQuantity(prep.id, newValue);
      setCart(getCart());
    }
  }

  const prepQuantity = !findInCart(cart, prep.id) ? quantity : cart.find(item => prep.id === item.prep_id).quantity;
  const mnn = prep.mnn !== '~' ? prep.mnn : '';

  const isBigDiscount = prep.min_old_price > 0
      && ((prep.min_old_price - prep.min_price) * 100 / prep.min_old_price) >= 9;

  const oldPrice = isBigDiscount ? <OldPrice>от {beautyPrice(prep.min_old_price)}  руб.</OldPrice> : null;

  if(isMobile) {
    return <MItem key={`mob_${prep.id}`}>
      <MItemPrepInfo>
        {<MItemPrepImage>
          {prep.image && (
              <Image src={prep.image} alt="" fill sizes="80px"
                     style={{ objectFit: 'contain' }} />
          )}
        </MItemPrepImage>}
        <MItemPrepContent>
          <MItemPrepName>{prep.rcfi_name} </MItemPrepName>
          <MItemPrepProducer>{prep.proizv_name}</MItemPrepProducer>
          {mnn && <MItemPrepMNN>{mnn}</MItemPrepMNN>}
          {prep.need_recipe == 1 && 
            <Recipe>{locales['receipt.need']}</Recipe>
          }
          {prep.is_synonim == 1 &&
              <div><SynonimBadge>Найденный аналог</SynonimBadge></div>
          }
        </MItemPrepContent>
      </MItemPrepInfo>
      <MItemMetaInfo>

        <MItemPrice>
          <MItemPriceCurrent>
            <small>от</small> {beautyPrice(prep.blocked_obj_id !== 0 ? (prep.min_old_price ?? prep.min_price) : prep.min_price)}<small>р</small>
          </MItemPriceCurrent>
          {prep.blocked_obj_id == 0 && isBigDiscount && <MItemPriceOld>от {beautyPrice(prep.min_old_price)} р</MItemPriceOld>}
        </MItemPrice>

        <MItemMetaContent>
        {prep.blocked_obj_id == 0 && <>
            <MItemInObject>В наличии в аптеках: {prep.objects_count}</MItemInObject>
            <MItemControls>
              <Counter value={prepQuantity} onChange={onCounterChange} minValue={getMinQuantity(prep.id)} step={getQuantityStep(prep.id)} maxValue={getMaxQuantity(null, prep.id)} />
              
              {cart && findInCart(cart, prep.id) && <div><RemoveFromCart onClick={() => removeFromCartHandler(prep.id)}></RemoveFromCart></div>}
              {cart && !findInCart(cart, prep.id) && <div><AddToCart onClick={() => addToCartHandler(prep)}></AddToCart></div>}
          
              {(prep.desc_id > 0 || prep.desc_ttmf_id > 0) && <MItemInfo href={`/info/${prep.desc_id}/${prep.desc_ttmf_id}`}>
                <Question>?</Question>
              </MItemInfo>}
            </MItemControls>
          </>}
          {prep.blocked_obj_id > 0 && <>
            <MItemInObject>В наличии в аптеках: {prep.objects_count}</MItemInObject>
            <MItemBlockedNote>{getBlockedText(prep.blocked_obj_id)}</MItemBlockedNote>
            <MItemControls>
              <div><PhoneToPharmacy onClick={() => openObjectsModal(prep.id)} target="_blank">✆</PhoneToPharmacy></div>
          
              {prep.desc_id > 0 && <MItemInfo href={`/info/${prep.desc_id}/${prep.desc_ttmf_id}`}>
                <Question>?</Question>
              </MItemInfo>}
            </MItemControls>
          </>}
        </MItemMetaContent>
      </MItemMetaInfo>
    </MItem>
  } else {
    return <TableString key={`des_${prep.id}`} $blocked={prep.blocked_obj_id > 0}>
      <div
          className={hovered ? 'hovered' : ''}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
      >
        {prep.image && (
          <Image
            src={prep.image}
             alt={prep.rcfi_name}
             fill
            sizes={hovered ? '600px' : '120px'}
             style={{ objectFit: 'contain' }}
         />
        )}
      </div>
      <PrepContainer>
        {prep.rcfi_name}

        {(prep.desc_id > 0 || prep.desc_ttmf_id > 0) &&
            <Info href={`/info/${prep.desc_id}/${prep.desc_ttmf_id}`} title="Фотографии, описание, инструкции">
              <Question>?</Question>
            </Info>
        }

        <Proizv>{prep.proizv_name}</Proizv>
        {mnn && <Mnn>{mnn}</Mnn>}
        {prep.need_recipe == 1 &&
            <Recipe>{locales['receipt.need']}</Recipe>
        }
        {prep.is_synonim == 1 &&
            <div><SynonimBadge>Найденный аналог</SynonimBadge></div>
        }
      </PrepContainer>

      {prep.blocked_obj_id == 0 && <>
        <Price>{oldPrice}от {beautyPrice(prep.min_price)} руб.</Price>
        <div>
          {prep.objects_count}
        </div>
        <div>
          <Counter value={prepQuantity} onChange={onCounterChange} minValue={getMinQuantity(prep.id)}
                   step={getQuantityStep(prep.id)} maxValue={getMaxQuantity(null, prep.id)}/>
        </div>

        {cart && findInCart(cart, prep.id) &&
            <div><RemoveFromCart onClick={() => removeFromCartHandler(prep.id)}></RemoveFromCart></div>}
        {cart && !findInCart(cart, prep.id) &&
            <div><AddToCart onClick={() => addToCartHandler(prep)}></AddToCart></div>}
      </>}
      {prep.blocked_obj_id > 0 && <>
        <Price>{prep.min_price > 0 ? `от ${beautyPrice(prep.min_old_price ?? prep.min_price)} руб.` : locales['product.analog_no_stock']}</Price>
        <div>{prep.objects_count}</div>
        <div>{getBlockedText(prep.blocked_obj_id)}</div>
        <div><PhoneToPharmacy onClick={() => openObjectsModal(prep.id)} target="_blank">✆</PhoneToPharmacy></div>
      </>}

    </TableString>
  }
}


const AddToCart = styled.a`
  display: inline-block;
  font-family: var(--font-awesome);
  padding: 2px 7px;
  background-color: var(--green);
  color: #fff;
  border: 1px solid var(--green);
  border-radius: 50%;

  &:hover {
    color: #fff !important;
  }
  
  @media (max-width: 480px) {
    border-radius: 5px;
    &::after{
      margin-left: 5px;
      content: 'Добавить';
      font-family: var(--font-regular);
      font-size: var(--text-normal);
      text-transform: uppercase;
    }
  }
`

const RemoveFromCart = styled.a`
  display: inline-block;
  font-family: var(--font-awesome);
  padding: 2px 7px;
  border: 1px solid var(--red);
  color: var(--red);
  border-radius: 50%;

  &:hover {
    color: var(--red) !important;
  }

  @media (max-width: 750px) {
    border-radius: 5px;
    &::after{
      margin-left: 5px;
      content: 'Удалить';
      font-family: var(--font-regular);
      font-size: var(--text-normal);
      text-transform: uppercase;
    }
  }
`

const PhoneToPharmacy = styled.a`
  display: inline-block;
  font-family: var(--font-awesome);
  color: #9c8450;
  font-size: 2.4rem;

  &:hover {
    color: #9c8450 !important;
  }

  @media (max-width: 750px) {
    border: 1px solid #9c8450;
    font-size: 1.4rem;
    border-radius: 5px;
    padding: 0 7px 2px;
    &::after {
      margin-left: 5px;
      content: 'Показать аптеки';
      font-family: var(--font-regular);
      font-size: var(--text-normal);
      text-transform: uppercase;
    }
  }
`

export const Proizv = styled.span`
  font-size: 0.9em;
  opacity: 0.8;
  display: block;
  width: 100%;
`

export const Mnn = styled.span`
  font-size: 0.9em;
  opacity: 0.5;
  display: block;
  width: 100%;
`

export const Recipe = styled(Proizv)`
  color: var(--red);
`

const PrepContainer = styled.div`
  position: relative;
`

const Info = styled.a`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  padding: 10px;
  z-index: 10;

  &:hover > span {
    color: #fff !important;
    opacity: 0.5;
  }

  @media (max-width: 750px) {
    top: -70px;
  }
`

const Question = styled.span`
  display: inline-block;
  font-family: var(--font-semibold);
  padding: 2px 9px;
  background-color: var(--green);
  color: #fff;
  border: 1px solid var(--green);
  border-radius: 50%;
  
`

const Price = styled.div`
  @media (max-width: 750px) {
    font-size: 1.25em;
    line-height: 1.25;
  }
  flex-direction: column;
  justify-content: center !important;
`

const OldPrice = styled.div`
  text-decoration: line-through;
  opacity: 0.65;
  font-size: 14px;
`


export const MItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  box-shadow: 0 0 8px 0 rgba(34, 60, 80, 0.3);
  border-radius: 5px;
  padding: 8px;
  margin-bottom: 8px;

`
const MItemPrepInfo = styled.div`
  display: flex;
  gap: 16px;
`
const MItemPrepImage = styled.div`
  width: 23%;
  position: relative;
  height: 80px;
  > img {
    object-fit: contain;
  }
`

const MItemPrepContent = styled.div`
  flex: 1;
  white-space: normal;
`
const MItemPrepName = styled.div`
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 4px;
`
const MItemPrepProducer = styled.div`
  font-size: 12px;
`
const MItemPrepMNN = styled.div`
  font-size: 12px;
  opacity: 0.6;
`

const MItemMetaInfo = styled.div`
  display: flex;
  gap: 16px;
`
const MItemPrice = styled.div`
  width: 23%;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  justify-content: center;
`
const MItemPriceCurrent = styled.div`
  font-size: 17px;
  font-weight: bold;

  > small {
    font-size: 0.6em;
  }
`
const MItemPriceOld = styled.div`
  text-decoration: line-through;
  font-size: 12px;
`
const MItemMetaContent = styled.div`
  flex: 1;
`
const MItemInObject = styled.div`
  font-size: 12px;
  margin-bottom: 6px;
`
const MItemBlockedNote = styled.div`
  font-size: 12px;
  color: #9c8450;
  margin-bottom: 6px;
`
const MItemControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
`

const MItemInfo = styled.a`
  > span {
    width: 25px;
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`
const SynonimBadge = styled(Proizv)`
  color: #31708f;
  background-color: #d9edf7;
  border: 1px solid #bce8f1;
  border-radius: 4px;
  padding: 2px 6px;
  display: inline-block;
  width: auto;
  margin-top: 4px;
  font-weight: var(--font-semibold);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;
